import React, { useState, memo, useMemo } from 'react'

import Tag from '@ublique/components/Tags'
import { Column, Row } from '@ublique/components/Grid'
import { TextInput } from '@ublique/components/TextInput'
import Button from '@ublique/components/Button'

import { isInvalidByField } from '../utils/form'
import { MAIL_TO } from '../constants'
import cn from 'classnames'

const MailTo = ({ t, mailTo, setFieldValue, submitted, disabled }) => {
  const [tempMailTo, setTempMailTo] = useState('')

  const onAddMailTo = () => {
    setFieldValue(MAIL_TO, [...mailTo, tempMailTo])
    setTempMailTo('')
  }

  const getOnRemoveMailTo = (mailToToRemove) => () => {
    setFieldValue(
      MAIL_TO,
      mailTo.filter((mailTo) => mailTo !== mailToToRemove)
    )
  }

  const handleTempMailToChange = (event) => setTempMailTo(event.target.value)

  const testMailExp = (mail) => {
    const regex = new RegExp(/^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/)
    return !regex.test(mail)
  }

  const getAddBtnStatus = () => {
    if (!tempMailTo) return true
    return testMailExp(tempMailTo)
  }

  const invalidStatus = useMemo(() => {
    return (
      isInvalidByField.mailTo({ value: mailTo, submitted }) ||
      (tempMailTo && testMailExp(tempMailTo))
    )
  }, [mailTo, submitted, tempMailTo])

  const invalidText = useMemo(() => {
    if (isInvalidByField.mailTo({ value: mailTo, submitted })) {
      return t('JobData.MAIL_TO_REQUIRED')
    } else {
      return t('JobData.TEMP_MAIL_TO_INVALID')
    }
  }, [invalidStatus, t])

  return (
    <>
      <Row>
        <Column md={8}>
          {mailTo.map((mailTo, i) => (
            <Tag
              key={i}
              title={t('CLEAR')}
              className='tag-ublique-item'
              filter
              onClick={getOnRemoveMailTo(mailTo)}
            >
              {mailTo}
            </Tag>
          ))}
        </Column>
      </Row>
      <Row>
        <Column md={8}>
          <div className='mail-to'>
            <TextInput
              id='temp-mail-to'
              className='mail-to__input'
              value={tempMailTo}
              labelText={t('JobData.MAIL_TO')}
              invalid={invalidStatus}
              invalidText={invalidText}
              onChange={handleTempMailToChange}
              placeholder={t('JobData.MAIL_TO_PLACEHOLDER')}
              disabled={disabled}
            />
            <Button
              className={cn('mail-to__btn', { invalid: invalidStatus })}
              disabled={getAddBtnStatus()}
              onClick={onAddMailTo}
            >
              +
            </Button>
          </div>
        </Column>
      </Row>
    </>
  )
}

export default memo(MailTo)
